import React from 'react'

const ScreenReader = () => {
  const screenReaders = [
    {
      name: "Screen Access For All (SAFA)",
      website: "http://safa-reader.software.informer.com/2.0",
      type: "Free",
    },
    {
      name: "Non Visual Desktop Access (NVDA)",
      website: "http://www.nvda-project.org/",
      type: "Free",
    },
    {
      name: "System Access To Go",
      website: "http://www.satogo.com/",
      type: "Free",
    },
    {
      name: "Thunder",
      website: "http://www.screenreader.net/index.php?pageid=11",
      type: "Free",
    },
    {
      name: "WebAnywhere",
      website: "http://webanywhere.cs.washington.edu/wa.php",
      type: "Free",
    },
    {
      name: "Hal",
      website: "http://www.yourdolphin.co.uk/productdetail.asp?id=5",
      type: "Commercial",
    },
    {
      name: "JAWS",
      website: "http://www.freedomscientific.com/Products/Blindness/JAWS",
      type: "Commercial",
    },
    {
      name: "Supernova",
      website: "http://www.yourdolphin.co.uk/productdetail.asp?id=1",
      type: "Commercial",
    },
    {
      name: "Window-Eyes",
      website: "http://www.gwmicro.com/Window-Eyes/",
      type: "Commercial",
    },
  ];

  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Screen Reader Access</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        
      >
        <div className="row mb-1 justify-content-between">
          <div className="col-lg-12 mb-1">
           
         
            <div className="table-responsive">
              <table className="table table-striped table-bordered">
                <thead>
              <tr>
                <th scope="col">Screen Reader</th>
                <th scope="col">Website</th>
                <th scope="col">Free/Commercial</th>
              </tr>
            </thead>
            <tbody>
              {screenReaders.map((reader, index) => (
                <tr key={index}>
                  <td>{reader.name}</td>
                  <td>
                    <a href={reader.website} target="_blank" rel="noopener noreferrer">
                      {reader.website}
                    </a>
                  </td>
                  <td>{reader.type}</td>
                </tr>
              ))}
            </tbody>
          </table>
            </div>

          

           
            </div>
          </div>
        </div>
      </div>
  )
}

export default ScreenReader